import request from '../untils/request';

// 提现申请列表
export const lianlianWithdrawList = params => {
  return request({
    url: '/shop/lianlian/withdrawal-list',
    params,
  });
};

// 提现申请处理
export const lianlianWithdrawHandle = params => {
  return request({
    url: '/shop/lianlian/withdrawal-handle',
    params,
  });
};

// 平台账号列表
export const lianlianAccountList = params => {
  return request({
    url: '/shop/lianlian/account-list',
    params,
  });
};

// 连连账号列表
export const lianlianAccountDetailList = params => {
  return request({
    url: '/shop/lianlian/lian-account-list',
    params,
  });
};

// 企业账号列表
export const lianlianEnterpriseList = params => {
  return request({
    url: '/shop/lianlian/enterprise-list',
    params,
  });
};

// 企业开户
export const lianlianEnterpriseAccount = params => {
  return request({
    url: '/shop/lianlian/enterprise-account',
    params,
  });
};

// 获取银行列表
export const lianlianBankList = params => {
  return request({
    url: '/shop/lianlian/bank-list',
    params,
  });
};

// 连连随机因子
export const lianlianRandom = params => {
  return request({
    url: '/shop/lianlian/random',
    params,
  });
};

// 连连企业提现
export const lianlianEnterpriseWithdraw = params => {
  return request({
    url: '/shop/lianlian/enterprise-withdrawal',
    params,
  });
};

// 连连企业提现二次确认
export const lianlianEnterpriseWithdrawSms = params => {
  return request({
    url: '/shop/lianlian/enterprise-withdrawal-sms',
    params,
  });
};

// 连连企业提现记录
export const lianlianEnterpriseWithdrawalList = params => {
  return request({
    url: '/shop/lianlian/enterprise-withdrawal-list',
    params,
  });
};

// 连连企业修改手机号
export const lianlianEnterprisePhoneModify = params => {
  return request({
    url: '/shop/lianlian/enterprise-phone-modify',
    params,
  });
};

// 连连企业修改手机号二次确认
export const lianlianEnterprisePhoneSms = params => {
  return request({
    url: '/shop/lianlian/enterprise-phone-sms',
    params,
  });
};

// 连连调节余额
export const lianlianAddBalance = params => {
  return request({
    url: '/shop/lianlian/lian-account-add-balance',
    params,
  });
};

export const lianlianExport = params => {
  return request({
    url: '/shop/lianlian/export',
    params,
  });
};

// 找回密码发短信
export const lianlianFindPassword = params => {
  return request({
    url: '/shop/lianlian/enterprise-find-password',
    params,
  });
};

// 找回密码验证
export const lianlianFindPasswordVerify = params => {
  return request({
    url: '/shop/lianlian/enterprise-find-password-verify',
    params,
  });
};

// 上传批量提现表格（注意参数）
export const lianlianUpload = params => {
  return request({
    url: '/shop/lianlian/upload',
    params,
  });
};
